import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { useDispatch, useSelector } from 'react-redux';
import { setColorUnique, setColor } from "../../../../store/color/colorSlice";

import { getHexCode } from "../../../../helpers/colorConvert";

import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import FontAwesomeIcon from '@ntag/react-fontawesome';

import {
  Container,
  Label,
  FieldWrapper,
  InputField,
  WarningText,
  ColorBox,
  InputAndColorBoxWrapper
} from './ColorPicker.styles';

const ColorPicker = () => {
  const { colorPickerVisible, alias } = useSelector((state) => state.color);
  const dispatch = useDispatch();

  const [userInput, setUserInput] = useState("RAL ");
  const validColor = userInput.length > 7 && !!getHexCode(userInput);
  
  useEffect(
    () => {
      if (validColor) {
        dispatch(setColorUnique(userInput));
        dispatch(setColor(userInput));
      } else {
        dispatch(setColorUnique(null));
      }
    }, [dispatch, userInput, validColor]
  )

  const handleChange = (event) => {
    const input = event.target.value;

    if (input.slice(0, 4) === "RAL ") {
      setUserInput(event.target.value);
    } else setUserInput("RAL ");
  }

  const colorSecondaryYellow = "#ffe400";
  return (
    <>
      <Container visible={colorPickerVisible}>
        <FieldWrapper>
          <Label>{alias.labelChooseYourOwnColor}</Label>
          <InputAndColorBoxWrapper>
            <InputField onChange={handleChange} value={userInput} maxLength={8} />
            {validColor && <ColorBox color={getHexCode(userInput)} />}
          </InputAndColorBoxWrapper>
        </FieldWrapper>

        {userInput.length > 7 && !validColor && (
          <WarningText>
            <FontAwesomeIcon
              icon={faTriangleExclamation}
              fill={colorSecondaryYellow}
            />
            {alias.ralColorNotFound}
          </WarningText>)
        }
      </Container>
    </>
  );
};

ColorPicker.propTypes = {
  visible: PropTypes.bool,
}

export default ColorPicker;
